import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import hidePersonaHeaderFirstRun from 'owa-favorites/lib/actions/v1/firstRun/markPersonaHeaderFirstRunCompleted';
import strings from 'owa-strings/owa-people-strings';
import { getPalette } from 'owa-theme';
import * as React from 'react';
import { logUsage } from 'owa-analytics';

export interface PersonaHeaderFirstRunProps {
    target: HTMLElement;
}

const styles = require('./PersonaHeaderFirstRun.scss');

export interface PersonaHeaderFirstRunState {
    delayTimerExpired: boolean;
    isVisible: boolean;
}

/**
 * Shows the first run experience the first time an user sees the PersonaHeader.
 */
export default class PersonaHeaderFirstRun extends React.Component<
    PersonaHeaderFirstRunProps,
    PersonaHeaderFirstRunState
> {
    private timer: NodeJS.Timer;
    private readonly popupDelay = 2000; // ms until the popup shows

    constructor(props: PersonaHeaderFirstRunProps) {
        super(props);
        this.state = { delayTimerExpired: false, isVisible: true };
    }

    componentDidMount() {
        this.timer = setTimeout(() => {
            this.setState({ delayTimerExpired: true });
            logUsage('PersonaHeaderFREShown');
        }, this.popupDelay);
    }

    componentWillUnmount() {
        this.cancelTimer();
    }

    render() {
        return (
            this.state.isVisible &&
            this.state.delayTimerExpired && (
                <Callout
                    backgroundColor={getPalette().themePrimary}
                    className={styles.callout}
                    gapSpace={10}
                    target={this.props.target}
                    isBeakVisible={true}
                    beakWidth={15}
                    setInitialFocus={false}
                    onDismiss={this.onDismiss}
                    directionalHint={DirectionalHint.rightCenter}>
                    <div className={styles.container}>
                        <h1 className={styles.title}>{strings.firstRunExperienceHeader}</h1>
                        <p className={styles.content}>{strings.firstRunExperienceContent}</p>
                        <DefaultButton
                            className={styles.button}
                            text={strings.firstRunExperienceButton}
                            onClick={this.onDismiss}
                        />
                    </div>
                </Callout>
            )
        );
    }

    private onDismiss = () => {
        hidePersonaHeaderFirstRun();
        this.setState({ isVisible: false });
    };

    private cancelTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
